/*import { addAjax } from './Ajax';
import { addHelpers } from './Helpers';
import { Selector, Collection } from './Collection';

const Framework = {
  init: function(selector?: Selector): Collection {
    return new Collection(selector);
  }
}

const framework = addHelpers(addAjax(Framework));

export { framework as $ };*/
import { Collection } from './Collection';
import { addHelpers } from './Helpers';
import { addNetwork } from './Network';
function select(selector) {
    return new Collection(selector);
}
const framework = addNetwork(addHelpers(select));
export { framework as $ };
